import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  TDiiaGetStatusAssetManagerRequest,
  TDiiaGetStatusResponse,
  TDiiaInitializeAssetManagerRequest,
  TDiiaInitializeResponse,
} from '~/store/diia/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const diiaSignInitializeAssetManager = createAsyncThunk<
  TDiiaInitializeResponse,
  TDiiaInitializeAssetManagerRequest
>(
  'diia/diiaSignInitializeAssetManager',
  async ({ managerId, applicationId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/identification/diia/sign/application/${applicationId}/asset-managers/${managerId}/initialize`
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const diiaSignGetStatusAssetManager = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusAssetManagerRequest
>(
  'diia/diiaSignGetStatusAssetManager',
  async ({ managerId, applicationId, requestId }, { rejectWithValue, signal }) => {
    try {
      const { data } = await api.get(
        `/identification/diia/sign/application/${applicationId}/asset-managers/${managerId}/get-status/${requestId}`,
        { signal }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const diiaSignGetFinalStatusAssetManager = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusAssetManagerRequest
>(
  'diia/diiaSignGetFinalStatusAssetManager',
  async ({ managerId, applicationId, requestId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/identification/diia/sign/application/${applicationId}/asset-managers/${managerId}/get-final-status/${requestId}`
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const diiaSignRetrieveDocsAssetManager = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusAssetManagerRequest
>(
  'diia/diiaSignRetrieveDocsAssetManager',
  async ({ managerId, applicationId, token, requestId }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.post(
        `/identification/diia/sign/application/${applicationId}/asset-managers/${managerId}/retrieve-documents/${requestId}`,
        null,
        { headers }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
